import { useState, useMemo, useRef, memo, useEffect, useContext } from 'react';
import { GetMedicalRequest } from '@/api/endpoints/Requests';
import { ReportContent, ReportHeader, ReportSearch } from '@/components/tableDrawer';
import { CategoryRequestCell, NameRequestCell } from './RowsCells/RowsData';
import BaseBtn from '@/components/tableDrawer/TableItems/components/tableActions/BaseBtn';
import Status from './RowsCells/Status/Status';
import { DateRequestCell } from './RowsCells/RowsData/DateRequestCell';
import { useNavigate } from 'react-router-dom';
import ActionBtn from '@/components/ActionBtn';
import { CRRender } from '@/components/crRender';
import { PATIENT_REQUEST_STATUS } from '@/data/status';
import { DomainContext } from '@/context/DomainContext';


const MedicalRequest = () => {

    const { setCustomSearchData } = useContext(DomainContext)

    const navigate = useNavigate();

    const columns = useMemo(() => [
    
        {
            Header: 'PatientName',
            accessor: 'PatientName',
            canSearch: true,
            visible: false,
        },
        {
            Header: 'Date',
            accessor: 'Date',
            type:"Date",
            isMulti: true,
            canSearch: true,
            visible: false,
        },
        {
            Header: 'patientName',
            Cell: ({ row: { original } }) => <NameRequestCell original={original} />
        },
        {
            Header: 'requestDate',
            Cell: ({ row: { original } }) => <DateRequestCell original={original} />
        },
        {
            Header: 'categoryName',
            Cell: ({ row: { original } }) => <CategoryRequestCell original={original} />
        },
        {
            Header: 'status',
            Cell: ({ row: { original } }) => <Status status={{ name: original?.orderStatus, id: original?.orderStatusId }} />
        },
        {
            Header: 'view',
            Cell: ({ row: { original } }) =>
                <BaseBtn onApply={() => viewRequestDetails(original)} title="show-details" className="details-info" reqAction="canGet" icon={"mdi:eye"} />,
        },
        {
            Header: 'action',
            accessor: 'action',
            Cell: ({ row: { original } }) =>
                <>
                    <CRRender
                        isRender={[PATIENT_REQUEST_STATUS?.Pending,
                        PATIENT_REQUEST_STATUS?.InformationRequested,
                        PATIENT_REQUEST_STATUS?.InformationResponded].includes(original?.orderStatusId)}>
                        <ActionBtn onApply={() => handleAddQuotation(original?.id, original)} title="add-quotation" className="details-info" icon={"mdi:eye"} />,
                    </CRRender>
                    <CRRender isRender={original?.orderStatusId === PATIENT_REQUEST_STATUS?.InitialPaymentReceived}>
                        <ActionBtn onApply={() => handleAdmission(original?.id, original)} title="add-mission" className="details-info" icon={"mdi:eye"} />,
                    </CRRender>
                    <CRRender isRender={original?.orderStatusId === PATIENT_REQUEST_STATUS?.InProgress}>
                        <ActionBtn onApply={() => handlePostServiceEntry(original?.id, original)} title="post-service" className="details-info" icon={"mdi:eye"} />,
                    </CRRender>
                </>
        },
    ], [])

    const viewRequestDetails = (original) =>
        navigate(`/panel/provider/medical-request/${original?.id}/${original?.orderStatusId}`)


    const handleAddQuotation = (id, requestDetails) => {
        // Handle add question action
        navigate('/panel/provider/medical-request/add-quotation', {
            state: {
                requestId: id,
                patientName: requestDetails?.patientName,
                serviceContext: {
                    category: requestDetails?.categoryName,
                    subcategory: requestDetails?.subCategoryName,
                    service: requestDetails?.service,
                    age: requestDetails?.age,
                    requestId: requestDetails?.id
                }
            }
        });
    };

    const handleAdmission = (id) =>
        navigate('/panel/provider/medical-request/admission', { state: { requestId: id } });

    const handlePostServiceEntry = (id) =>
        navigate('/panel/provider/medical-request/post-service-entry', { state: { requestId: id } });

    return (
        <>
            <ReportContent tableAPI={GetMedicalRequest} columns={columns}>
                <ReportHeader  >
                    <ReportSearch />
                </ReportHeader>
            </ReportContent>
        </>
    );
}

export default memo(MedicalRequest);